module.exports = __webpack_public_path__ + "static/img/map.da47710.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/map.png
// module id = OeNr
// module chunks = 0